import { Navigate, Outlet, useNavigate, useOutletContext, useParams } from 'react-router-dom'

import Loading from 'modules/core/components/Loading'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useNavigation } from 'modules/core/hooks/useNavigation'

import { useIncidenceFilterContext } from 'modules/bookkeepers/lib/IncidenceFilterContext'
import policies, { PoliciesProvider } from 'modules/payroll_bundle/store/collections/policies'

const PayrollExportsPage = () => {
  const { selectedCompany: filterContextCompany } = useIncidenceFilterContext()
  const selectedCompanyId = filterContextCompany?.attributes.id ?? null
  const { policyId, periodId } = useParams()
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  const { loading } = useAsyncData(
    () =>
      policies.fetch({
        data: {
          bookkeeper_view: true,
        },
      }),
    []
  )

  if (loading) {
    return <Loading />
  }

  const onClose = () => {
    return navigate(
      navigation.bookkeepers.clients.payrollResults.payrollPolicy.payrollPolicyPeriodId.fullPath({
        periodId: String(periodId),
        policyId: String(policyId),
      })
    )
  }

  if (!policyId) {
    const companyPolicy = policies.find({
      company_id: selectedCompanyId,
      default: true,
    })

    if (companyPolicy) {
      return (
        <Navigate
          to={navigation.bookkeepers.clients.payrollResults.payrollPolicy.payrollPolicyPeriodId.fullPath(
            {
              periodId: periodId ?? '',
              policyId: companyPolicy.attributes.id!,
            }
          )}
        />
      )
    }
  }

  return (
    <PoliciesProvider collection={policies}>
      <Outlet context={{ selectedCompany: selectedCompanyId, onClose }} />
    </PoliciesProvider>
  )
}

export const usePayrollExportsContext = () =>
  useOutletContext<{ selectedCompany: string | null; onClose: () => void }>()

export default PayrollExportsPage
